import Repository from './repository'

export default {
  MensagensGet() {
    return Repository.get('/coach-messages')
  },
  MensagensGetId(id) {
    return Repository.get(`/coach-messages/${id}`)
  },
  MensagensPut(id, item) {
    return Repository.put(`/coach-messages/${id}`, item)
  },
  MensagensPost(item) {
    return Repository.post(`/coach-messages`, item)
  },
  MensagensDelete(id) {
    return Repository.delete(`/coach-messages/${id}`)
  },
  MensagensUpload(formData) {
    return Repository.post(`/coach-messages/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
